import { BizError, LoginParam } from "@/models/biz_model"
import { store, useAppDispatch } from "@/store"
import {
  LoginApiVersion,
  LoginStatus,
  ViewType,
  changeViewType,
  pcLogin,
  selectChangePasswordPrompt,
  setLoginApiVersion,
  updateCurrentUser,
  updateLoginStatus,
  userAutoLogin,
  userLoginNew,
  userLoginOld,
} from "@/stores/login_slice"
import { UserUsecase } from "@/usecases/user"
import { DeviceUseCase } from "@/usecases/device"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

export function useLoginNew() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const loginNew = async (param: LoginParam): Promise<boolean> => {
    // 登录
    try {
      await dispatch(userLoginNew(param)).unwrap()
      // 若已弹出修改初始密码提示，则停留在登录页等用户决策，暂不跳转
      if (selectChangePasswordPrompt(store.getState())) {
        return true
      }
      // 跳转到云桌面页面
      navigate("/remoteDesk")
      return true
    } catch (e: any) {
      console.error("login_hook useLoginNew error: ", e)
      return false
    }
  }
  return loginNew
}

export function useLoginOld() {
  const dispatch = useAppDispatch()

  const loginOld = async (param: LoginParam): Promise<boolean> => {
    // 登录
    try {
      await dispatch(userLoginOld(param)).unwrap()
      return true
    } catch (e: any) {
      console.error("login_hook useLoginOld error: ", e)
      return false
    }
  }
  return loginOld
}

// 自动登录（双重验证场景下，验证码页继续走 token + deviceSecret 路径）
export function useLoginAuto() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const loginAuto = async (params: {
    phone?: string
    smsCode?: string
    smsToken?: string
  }): Promise<boolean> => {
    try {
      await dispatch(userAutoLogin(params)).unwrap()
      if (selectChangePasswordPrompt(store.getState())) {
        return true
      }
      navigate("/remoteDesk")
      return true
    } catch (e: any) {
      console.error("login_hook useLoginAuto error: ", e)
      return false
    }
  }
  return loginAuto
}

export let clientDigit: string | null
export let assistLoginType: string | null
export let isAssistLogin: boolean = false
export let loginTypeUrlParam: string | null
export let ksType: string | null

// 处理登录链接参数
export function useProcessUrlParams() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  // 企业登录
  const ksLogin = (params: URLSearchParams) => {
    try {
      const res = UserUsecase.parseKCLoginParams(params)
      if (res instanceof BizError) {
        dispatch(
          updateLoginStatus({
            msg: res.displayErrorMsg,
            status: LoginStatus.error,
          })
        )
        return
      }

      const { user, hasSetPass } = res.unwrap()
      // 更新当前用户信息
      dispatch(updateCurrentUser(user))

      // 是否设置过密码 0-否 1-是
      if (hasSetPass === 0) {
        dispatch(changeViewType(ViewType.setKCPwd))
      } else if (hasSetPass === 1) {
        dispatch(changeViewType(ViewType.login))
        dispatch(setLoginApiVersion(LoginApiVersion.newApi))
      }
    } catch (e) {
      console.error("KS Login error: ", e)
    }
  }

  // 个人用户登录
  const pcUserLogin = async (params: URLSearchParams) => {
    try {
      const res = UserUsecase.parsePCParams(params)

      if (res instanceof BizError) {
        dispatch(
          updateLoginStatus({
            msg: res.displayErrorMsg,
            status: LoginStatus.error,
          })
        )
        return
      }
      const { desktopId, deviceId, user } = res.unwrap()

      // 获取本地设备ID（用于上报数据）
      const devLocalIdRes = await DeviceUseCase.getLocalDeviceId()
      if (devLocalIdRes instanceof BizError) {
        return devLocalIdRes
      }
      const localDevId = devLocalIdRes.unwrap()

      const userNew = { ...user, localDevId }

      // 切换到  个人用户登录
      dispatch(changeViewType(ViewType.pcLogin))
      // 连接到云桌面
      await dispatch(pcLogin({ user: userNew, desktopId, deviceId })).unwrap()
      // 跳转到云桌面页面
      navigate("/remoteDesk")
    } catch (e) {
      console.error("PC Login error: ", e)
    }
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)

    loginTypeUrlParam = urlParams.get("type")
    clientDigit = urlParams.get("client")
    assistLoginType = urlParams.get("loginType")
    // 远程协助链接
    isAssistLogin = loginTypeUrlParam === "PCC" && assistLoginType === "assist"

    switch (loginTypeUrlParam) {
      case null:
        // 账号密码登录
        break
      case "PCC":
        // 个人用户登录
        pcUserLogin(urlParams)
        break
      case "KC":
        // 企业登录
        ksLogin(urlParams)
        break
    }
  }, [])
}
